import Button from '@/components/Button'
import Input from '@/components/Input'
import Title from '@/components/Title'
import { GxForm, GxIcon } from '@garpix/garpix-web-components-react'
import { closeIcon, checkIcon, zheka2 } from '@/images'
import React from 'react'
import style from './styles/enter_tourn.module.scss'
import { useCurrentUser, useModal, usePage } from '@/hooks'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { api } from '@/api'
import { tournamentRegistrationSchema } from '@/utils/schemesFormik'
import ErrorAllText from '@/components/ErrorText/AllErros'
import { StateSelect } from '@/components/Select'

const EnterTournament = (): React.ReactElement => {
  const page = usePage()
  const { closeModal, modalProps } = useModal()
  const { currentUser } = useCurrentUser()
  const { config } = page?.init_state?.global

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: tournamentRegistrationSchema,
    initialValues: {
      birthday: currentUser.personal_birthday,
      email: currentUser.email,
      tournament: modalProps?.tournamentId,
      state: currentUser.personal_state,
      city: currentUser.personal_city,
      apiError: ''
    },
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit (values, { setSubmitting, setErrors, setStatus }) {
      api
        .tournamentRegistration(values)
        .then(() => {
          setStatus('success')
          setSubmitting(false)
        })
        .catch((err: any) => {
          setErrors({ apiError: err?.response?.data?.errorText })
          setSubmitting(false)
        })
    }
  })

  const onSubmit = formik.submitForm

  const { gameId } = modalProps

  const status = formik.status

  if (status !== 'success') {
    return (
      <GxForm onGx-submit={onSubmit}>
        {/* Step 1 */}
        <Title type='h2' theme='h3' className={style.enter__title}>
          Принять участие в Турнире
        </Title>
        <p className={style.enter__text}>
          Введите почту для участия в турнире На почту будут приходить уведомления
          и новости о будущих турнирах.
        </p>
        <Input
          name='email'
          label='Почта:'
          type='email'
          required
          className={style.enter__input}
          value={formik.values.email}
          onGx-input={formik.handleChange}
          error={formik.errors.email}
        />
        <Input
          name='birthday'
          label='Дата рождения:'
          type='text'
          placeholder='дд.мм.гггг'
          required
          value={formik.values.birthday}
          onGx-input={formik.handleChange}
          error={formik.errors.birthday}
          className={style.enter__input}
        />
        <StateSelect
          label='Регион:'
          // placeholder='Регион'
          // theme='secondary'
          name='state'
          className={style.enter__input}
          value={formik.values.state}
          onGx-change={formik.handleChange}
          clearable
          required
        />
        <Input
          name='city'
          label='Город:'
          type='text'
          // placeholder='дд.мм.гггг'
          required
          value={formik.values.city}
          onGx-input={formik.handleChange}
          error={formik.errors.city}
          className={style.enter__input}
        />
        <div>
          {formik?.errors?.apiError === ''
            ? null
            : (
              <ErrorAllText text={formik.errors.apiError} />
              )}
        </div>
        <div className={style.enter_buttons}>
          <Button
            size='large'
            wide
            theme='secondary'
            highlight
            className={style.enter__button}
            onClick={closeModal}
          >
            <GxIcon
              src={closeIcon}
              slot='icon-left'
              className={style.enter__button_icon}
            />
            Отменить
          </Button>
          <Button type='submit' size='large' wide highlight className={style.enter__button}>
            <GxIcon
              src={checkIcon}
              slot='icon-left'
              className={style.enter__button_icon}
            />
            Принять
          </Button>
        </div>
      </GxForm>
    )
  }
  return (
    <>
      {/* Step 2 */}
      <Title type='h2' theme='h3' className={style.enter__title}>
        Теперь ты участник турнира!
      </Title>
      <div className={style.enter_flex}>
        <div>
          <p className={style.enter__text}>
            <span className={style.enter__text_block}>
              На почту в ближайшее время придет инструкция о дальнейших
              действиях и уведомление о начале турнира.
            </span>
            <span className={style.enter__text_block}>
              Следи за событиями турнира в разделе{' '}
              <Link onClick={closeModal} to={config.news} className={style.enter__link}>
                Новости
              </Link>
              !
            </span>
            <span className={style.enter__text_block}>Удачи в игре!</span>
          </p>

          <Button
            href={`${config.detail_game}?element_id=${String(gameId)}`}
            size='large'
            wide
            theme='secondary'
            highlight
            className={style.enter__button}
          >
            Скачать игру
          </Button>
        </div>

        <img
          src={zheka2}
          width='231px'
          height='309px'
          alt=''
          className={style.enter__image}
        />
      </div>
    </>
  )
}

export default EnterTournament
